import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const RequireVendorAdmin = ({ children }) => {
  const { isAdmin, isVendorAdmin } = useAuth();

  if (!isAdmin && !isVendorAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RequireVendorAdmin;
